import { Checkbox, Radio } from 'react-icheck';
import { API, Helpers, Router } from '../Helpers';
import { InputHidden, InputText } from '../Core';
import IonRangeSlider from 'react-ion-slider';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReviewRating } from '../Shared';
import Select from 'react-select';

export default class ToursList extends Component {
    constructor(props) {
        super(props);

        const { filtered_locations } = this.props.data;
    
        if(!_.isEmpty(filtered_locations)){
        this.props.data.locations.data = filtered_locations;
        }

        this.state = {
            cart: this.props.data.cart,
            location: _.find(this.props.data.locations.data, (_location) => { return _location.slug == this.props.data.payload.location; }),
            tours: this.props.data.tours,
            sort_by: this.props.data.sort_by
        };
        
        this.changeLocation = this.changeLocation.bind(this);
        this.changeSortBy = this.changeSortBy.bind(this);
        this.findProductCoverPhoto = this.findProductCoverPhoto.bind(this);
        this.findTourListingCtaText = this.findTourListingCtaText.bind(this);
        this.generateProductUrl = this.generateProductUrl.bind(this);
        this.getLocationOptions = this.getLocationOptions.bind(this);
        this.inCart = this.inCart.bind(this);
        this.nextCount = this.nextCount.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.loadMoreTours = this.loadMoreTours.bind(this);
        this.toCount = this.toCount.bind(this);
        this.urlParams = this.urlParams.bind(this);
    }

    componentDidMount() {

        //update selection location from destination param
        const searchParams = new URLSearchParams(document.location.search);
        // console.log("category", searchParams.get('destination'));
        const slug = searchParams.get('destination');
        const location = _.find(this.props.data.locations.data, (_location) => {
          return _location.slug == slug;
        });
    
        if(location)
          this.changeLocation(location);
    }
    
    changeLocation(location)
    {
        //console.log("changeLocation", location);
        
        this.setState({
            location: location
        }, () => {
            this.updateTours();
            const searchParams = new URLSearchParams(document.location.search);
            searchParams.set('destination', location.slug); 
            const newUrl = window.location.protocol 
                    + '//' + window.location.host 
                    + window.location.pathname + '?' 
                    + searchParams.toString();

            window.history.pushState({ path: newUrl }, '', newUrl);
        });
    }
    
    changeSortBy(sort_by)
    {
        this.setState({
            sort_by: sort_by
        }, () => 
        {
            this.updateTours();
        });
    }
    
    findProductCoverPhoto(tour)
    {
        if (!_.isEmpty(tour.cover_photo))
        {
            return tour.cover_photo.medium;
        }
        
        return '/images/placeholder-16-9.jpg';
    }
    
    findTourListingCtaText()
    {
        let tour_listing_cta_text = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'tour_listing_cta_text'; });
        
        if (!_.isEmpty(tour_listing_cta_text))
        {
            return tour_listing_cta_text.value;
        }
    }
    
    generateProductUrl(tour)
    {
        const router = Router(this.props.data.routes);
        
        let params = {
            domain: this.props.data.active_site.domain, 
            id: tour.id, 
            tour_slug: tour.slug
        };
        
        if (!_.isEmpty(this.state.location))
        {
            if (!_.isEmpty(this.state.location.region_slug) && !_.isNull(this.state.location.region_slug))
            {
                params.region_slug = this.state.location.region_slug;

                if (!_.isEmpty(this.state.location.country_slug) && !_.isNull(this.state.location.country_slug))
                {
                    params.country_slug = this.state.location.country_slug;

                    return router.url('tours.show_region', params);
            }
            
            }
            
            if (!_.isEmpty(this.state.location.country_slug) && !_.isNull(this.state.location.country_slug))
            {
                params.country_slug = this.state.location.country_slug;

                return router.url('tours.show_country', params);
            }
            
        }
        
        return router.url('tours.show', params);
    }
    
    getLocationOptions()
    {
        const location_groups = _.groupBy(this.props.data.locations.data, 'country_name');
        const countries = _.keysIn(location_groups);
        
        let location_options = [];
        
        _.forEach(countries, (country) => {
            
            let options = [];
            
           _.forEach(location_groups[country], (location) => {
               
               location.label = location.region;
               
                if (_.isEmpty(location.label))
                {  
                    location.label = location.country_name;
                }
               
                location.value = location.slug;
            
                options.push(location);
            });
            
            location_options.push({
                label: country,
                options: _.sortBy(options, ['label'])
            });
        });
        
        return _.sortBy(location_options, ['label']);
    }
    
    inCart(tour)
    {
        let index = _.findIndex(this.state.cart.items, (_item) => { return tour.name == _item.name; });
        
        if (index > -1)
        {
            return true;
        }
        
        return false;
    }
    
    nextCount()
    {
        if ((this.state.tours.meta.pagination.total - (this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page)) < this.state.tours.meta.pagination.per_page)
        {
            return this.state.tours.meta.pagination.total - this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page;
        }
        
        return this.state.tours.meta.pagination.per_page;
    }
    
    showLoader()
    {
        //console.log("showLoader");
        
        this.setState({
            show_loader: true
        });
    }
    
    loadMoreTours(page)
    {
        //console.log("loadMoreTours");
        
        const router = Router(this.props.data.routes);
        
        let payload = this.urlParams(page);
        
        //console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                //console.log("loadMoreTours response", response);
                
                let tours = {...this.state.tours};
                
                tours.data = tours.data.concat(response.data);
                tours.meta = response.meta;
                
                this.setState({
                    tours: tours,
                    loading_more_tours: false
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            loading_more_tours: true
        }, () => 
        {
            API.get(onResponse, router.url('api.tours.index', payload));
        });
    }
    
    updateTours()
    {
        //console.log("updateTours");
        
        const router = Router(this.props.data.routes);
        
        let payload = this.urlParams();
        
        //console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                //console.log("updateTours response", response);
                
                this.setState({
                    tours: response,
                    show_loader: false
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            show_loader: true
        }, () => 
        {
            API.get(onResponse, router.url('api.tours.index', payload));
        });
    }
    
    toCount()
    {
        return this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page < this.state.tours.meta.pagination.total ? this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page : this.state.tours.meta.pagination.total;
    }
    
    urlParams(page)
    {
        let params = _.omit(this.props.data.payload, ['location', 'sort_by']);
        
        params = _.assign({ sort_by: this.state.sort_by.slug }, params);
        
        if (!_.isEmpty(this.state.location))
        {
            params = _.assign({ location: this.state.location.slug }, params);
        }
        
        if (page > 1)
        {
            params = _.assign({ page: page }, params);
        }
        
        return params;
    }
        
    render() {
        
        const { active_site, locations, order_by_options, request, routes, env} = this.props.data;
        const router = Router(routes);
        const tour_listing_cta_text = this.findTourListingCtaText();
        
        return (
            <div>
                <div className="container p-0">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <Select 
                                    options={this.getLocationOptions()} 
                                    onChange={(value) => {this.changeLocation(value)}}
                                    value={!_.isEmpty(this.state.location) ? this.state.location : ''}
                                    placeholder="Choose your destination..."
                                    styles={{
                                        control: (provided, state) => ({
                                        ...provided,
                                        padding: '0.5rem'
                                      })
                                    }}
                                />
                            </div>
                            
                        
                            {
                                !_.isEmpty(this.state.tours.data) &&
                                <div className="row mb-1">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="mb-2 text-muted"><span className="mr-2">Viewing</span>1 — {this.toCount()} of {this.state.tours.meta.pagination.total}</div>
                                            <div>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item text-muted">
                                                        Sort by
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <button className="btn btn-flat dropdown-toggle no-caret px-1" type="button" data-toggle="dropdown">
                                                            <span className="primary-text">{this.state.sort_by.display_as}<i className="fa fa-fw fa-angle-down ml-1"></i></span>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                            {
                                                                order_by_options.data.map((order_by_option, key) => {

                                                                    return (

                                                                        <button 
                                                                            key={key} 
                                                                            className="dropdown-item d-flex justify-content-between"
                                                                            name="sort_by"
                                                                            type="button"
                                                                            onClick={() => {this.changeSortBy(order_by_option)}}>
                                                                            <div className="mr-4">{order_by_option.display_as}</div>

                                                                            {
                                                                                order_by_option.slug == this.state.sort_by.slug &&
                                                                                <div><i className="fa fa-check text-success"></i></div>
                                                                            }
                                                                        </button>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                !_.isEmpty(this.state.tours.data) ?
                                <div>
                                    {
                                        this.state.tours.data.map((tour, key) => {

                                            const product_url = this.generateProductUrl(tour);
                                            const product_cover_photo = this.findProductCoverPhoto(tour);

                                            let pricingType = _.find(tour.tags.data, (_tag) => { return _tag.tag_group_name === "Pricing Type"; })
                                            pricingType = !_.isEmpty(pricingType) ? pricingType.name : "per person";

                                            return (
                                                <div key={key} className="row mb-4 waypoint">
                                                    <div className="col-12">
                                                        <div className="position-relative">
                                                            <a className="d-md-none" href={product_url}>
                                                                <div className="card rounded-0">
                                                                    <div className="card-image overflow-hidden position-relative">
                                                                        <img className="img-fluid" src={product_cover_photo} />

                                                                        {
                                                                            this.inCart(tour) &&
                                                                            <div className="position-absolute card z-depth-0 border-black" style={{ top: '10px', right: '10px' }} tabIndex="0">
                                                                                <div className="card-body text-center p-2 black primary-text">
                                                                                    <i className="fa fa-shopping-cart mr-2"></i><i className="fa fa-check"></i>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>

                                                                    <div className="card-body border-top-0">
                                                                        {
                                                                            !_.isNull(tour.average_rating) &&
                                                                            <ReviewRating 
                                                                                star_rating={tour.average_rating}
                                                                                count={tour.reviews_count}
                                                                            />
                                                                        }

                                                                        <h4 className="three-b-text font-weight-bold body-font mb-3">
                                                                            {tour.name}
                                                                        </h4>

                                                                        {
                                                                            !_.isEmpty(tour.date_settings) &&
                                                                            !_.isEmpty(tour.date_settings.duration) &&
                                                                            <div className="mb-3 body-text-color font-small"><i className="far fa-clock mr-1"></i><span className="font-small">{tour.date_settings.duration}</span></div>
                                                                        }     

                                                                        <div className="mb-4">
                                                                            <div className="media">
                                                                                <div className="mr-2 align-self-center">
                                                                                    <h4 className="m-0 body-font primary-text">
                                                                                        <span className="font-weight-bold">{env.CURRENCY+' '+Helpers.formatNoDecimalCurrency(tour.price)}</span>
                                                                                    </h4>
                                                                                </div>
                                                                                <div className="media-body align-self-center">
                                                                                    <div className="m-0 font-weight-bold body-text-color" style={{ lineHeight: 0.75 }}><span className="font-small">Starting From</span></div>
                                                                                    <span className="font-small body-text-color">{_.lowerCase(pricingType)}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {
                                                                            !_.isEmpty(tour.inclusions) &&
                                                                            <div>
                                                                                <ul key="includes" className="list-inline mb-0 font-small">
                                                                                    <li className="list-inline-item mr-3">
                                                                                        <span className="font-weight-bold body-text-color">Includes:</span>
                                                                                    </li>

                                                                                    {
                                                                                        tour.inclusions.map((inclusion, key) => {

                                                                                            return (
                                                                                                <li key={key}
                                                                                                    className="list-inline-item mr-3 body-text-color">
                                                                                                    <i className={inclusion.icon + " fa mr-1"}></i>{inclusion.name}
                                                                                                </li>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        }
                                                                    </div>

                                                                    { 
                                                                        !_.isEmpty(tour_listing_cta_text) &&
                                                                        <div className="card-footer white p-2">
                                                                            <div className="text-right">
                                                                                <button className="btn btn-link primary-text">{tour_listing_cta_text}<i className="fa fa-angle-right ml-2"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </a>

                                                            <a className="d-none d-md-block" href={product_url}>
                                                                <div className="card z-depth-0 rounded-0">
                                                                    <div className="container p-0">
                                                                        <div className="row no-gutters">
                                                                            <div className="col-md-6 background-cover position-relative" style={{ backgroundImage: "url(" + product_cover_photo + ")", minHeight: '250px' }}>
                                                                                {
                                                                                    this.inCart(tour) &&
                                                                                    <div className="position-absolute card z-depth-0 border-black" style={{ top: '10px', right: '10px' }} tabIndex="0">
                                                                                        <div className="card-body text-center p-2 black primary-text">
                                                                                            <i className="fa fa-shopping-cart mr-2"></i><i className="fa fa-check"></i>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="p-4 h-100">
                                                                                    {
                                                                                        !_.isNull(tour.average_rating) &&
                                                                                        <ReviewRating 
                                                                                            star_rating={tour.average_rating}
                                                                                            count={tour.reviews_count}
                                                                                        />
                                                                                    }

                                                                                    <h3 className="three-b-text font-weight-bold body-font mb-3">
                                                                                        {tour.name}
                                                                                    </h3>

                                                                                    {
                                                                                        !_.isEmpty(tour.date_settings) &&
                                                                                        !_.isEmpty(tour.date_settings.duration) &&
                                                                                        <div className="mb-3 body-text-color font-small"><i className="far fa-clock mr-1"></i>{tour.date_settings.duration}</div>
                                                                                    }     

                                                                                    <div className="d-flex mb-4">
                                                                                        <div className="media">
                                                                                            <div className="mr-2 align-self-center">
                                                                                                <h3 className="m-0 body-font primary-text">
                                                                                                    <span className="font-weight-bold">{Helpers.formatNoDecimalCurrency(tour.price)}</span>
                                                                                                </h3>
                                                                                            </div>
                                                                                            <div className="media-body align-self-center">
                                                                                                <div className="m-0 font-weight-bold body-text-color" style={{ lineHeight: 0.75 }}><span>Starting From</span></div>
                                                                                                <span className="font-small body-text-color">{_.lowerCase(pricingType)}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {
                                                                                        !_.isEmpty(tour.inclusions) &&
                                                                                        <div className="mb-4">
                                                                                                <ul className="list-inline mb-0 font-small">
                                                                                                    <li className="list-inline-item mr-3">
                                                                                                        <span className="font-weight-bold body-text-color">Includes:</span>
                                                                                                    </li>

                                                                                                    {
                                                                                                        tour.inclusions.map((inclusion, key) => {

                                                                                                            return (
                                                                                                                <li key={key}
                                                                                                                    className="list-inline-item mr-3 body-text-color">
                                                                                                                    <i className={inclusion.icon + " fa mr-1"}></i>{inclusion.name}
                                                                                                                </li>
                                                                                                            )
                                                                                                        })
                                                                                                    }
                                                                                                </ul>
                                                                                        </div>
                                                                                    }

                                                                                    { 
                                                                                        !_.isEmpty(tour_listing_cta_text) &&
                                                                                        <div className="text-right">
                                                                                            <button className="btn btn-link primary-text">{tour_listing_cta_text}<i className="fa fa-angle-right ml-2"></i></button>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div> :
                                <div className="row">
                                    <div className="col-12">
                                        <div className="media">
                                            <div className="align-self-start mr-3 d-none d-lg-block">
                                                <i className="fa fa-4x fa-exclamation-circle text-danger"></i>
                                            </div>
                                            <div className="media-body">
                                                <h2 className="d-none d-lg-block body-font font-weight-bold">
                                                    <span className="font-largest">No matching tours found...</span>
                                                </h2>

                                                <h3 className="mb-4 d-lg-none body-font font-weight-bold">
                                                    <span className="font-largest">No matching tours found...</span>
                                                </h3>

                                                <div className="font-larger mb-3">This is most likely because too many filters have been selected. Maybe try less filters?</div>

                                                <form onSubmit={this.showLoader}>
                                                    <button type="submit" className="btn btn-rounded btn-outline-four-b four-b-text m-0">
                                                        <span className="font-weight-bold mr-2">Reset filters</span><i className="fa fa-lg fa-undo"></i>
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                !_.isEmpty(this.state.tours.data) &&
                                <div className="row">
                                    <div className="col-12 col-lg-6 mx-auto">
                                        <div className="text-center">
                                            <div className="mb-2 text-muted"><span className="mr-2">Viewing</span>1 — {this.toCount()} of {this.state.tours.meta.pagination.total}</div>

                                            {
                                                this.state.tours.meta.pagination.current_page < this.state.tours.meta.pagination.total_pages &&
                                                <div>
                                                    <button 
                                                        className="btn btn-primary btn-block py-4 mb-2"
                                                        type="button"
                                                        onClick={() => {this.loadMoreTours(this.state.tours.meta.pagination.current_page + 1)}}>

                                                        <ul className="list-inline mb-0 d-flex align-items-center justify-content-center">
                                                            {
                                                                this.state.loading_more_tours &&
                                                                <li className="list-inline-item mr-3">
                                                                    <div className="spinner-border spinner-border-md d-block" role="status"></div>
                                                                </li>
                                                            }

                                                            <li className="list-inline-item">
                                                                {
                                                                    (this.state.tours.meta.pagination.total - this.toCount()) <= this.state.tours.meta.pagination.per_page ?
                                                                    <span className="font-weight-bold font-large">Show all remaining tours<i className="fa fa-lg fa-fw fa-angle-down ml-3"></i></span> :
                                                                    <span className="font-weight-bold font-large">Show the next {this.nextCount()} tours<i className="fa fa-lg fa-fw fa-angle-down ml-3"></i></span>
                                                                }
                                                            </li>
                                                        </ul>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    {
                        this.state.show_loader &&
                        <div className="view viewport-height position-fixed three-b opacity-75 w-100 z-max" style={{ left: 0, top: 0, bottom: 0, right: 0 }}>
                            <div className="progress md-progress primary-color z-3 mb-0">
                                <div className="indeterminate"></div>
                            </div>

                            <div className="mask d-flex justify-content-center align-items-center">
                                <div className="preloader-wrapper active crazy">
                                    <div className="spinner-layer spinner-red-only spinner-primary">
                                        <div className="circle-clipper left">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

if (document.getElementById('toursList')) {
    
    const element = document.getElementById('toursList');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<ToursList data={JSON.parse(data.data)} />, document.getElementById('toursList'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/ToursList.js